module.exports = __webpack_public_path__ + "img/15.fc13153c.png";